const raw = import.meta.env.VITE_SUPPORTED_PERSONAS || 'consumer';
export const SUPPORTED_PERSONAS: string[] = raw.split(',').map((s: string) => s.trim());
export const personaQueryParam = SUPPORTED_PERSONAS.join(',');
